import { AuthorizationInformationConstants } from './authorizationInformation.constants'
import { IAuthorizationInformationState, IAuthorizationInformationAction } from './authorizationInformation.types'

export const initialAuthorizationInformationState: IAuthorizationInformationState = {
  transportAuthorizationCode: '',
  reasonForInterfacilityTransfer: null,
  reasonForInterfacilityTransferPNNV: null,
  justificationForTransfer: '',
}

export function authorizationInformationReducer(
  state: IAuthorizationInformationState = initialAuthorizationInformationState,
  action: IAuthorizationInformationAction
): IAuthorizationInformationState {
  switch (action.type) {
    case AuthorizationInformationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case AuthorizationInformationConstants.SET_TRANSPORTAUTHORIZATIONCODE:
      return { ...state, transportAuthorizationCode: action.transportAuthorizationCode }
    case AuthorizationInformationConstants.SET_REASONFORINTERFACILITYTRANSFER:
      return { ...state, reasonForInterfacilityTransfer: action.reasonForInterfacilityTransfer }
    case AuthorizationInformationConstants.SET_REASONFORINTERFACILITYTRANSFER_PNNV:
      return { ...state, reasonForInterfacilityTransferPNNV: action.reasonForInterfacilityTransferPNNV }
    case AuthorizationInformationConstants.SET_JUSTIFICATIONFORTRANSFER:
      return { ...state, justificationForTransfer: action.justificationForTransfer }
    case AuthorizationInformationConstants.SET_AUTHORIZATION_INFORMATION_STATE:
      return { ...state, ...action.authorizationInformationState }
    case AuthorizationInformationConstants.RESET_STATE:
      return {
        transportAuthorizationCode: '',
        reasonForInterfacilityTransfer: null,
        reasonForInterfacilityTransferPNNV: null,
        justificationForTransfer: '',
      }
    default:
      return state
  }
}
